import { FC, SVGAttributes } from 'react';

const StateInfo: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" {...props}>
      <path
        d="M13.1832 7.52775C13.1832 8.18111 12.6535 8.71077 12.0002 8.71077C11.3468 8.71077 10.8171 8.18111 10.8171 7.52775C10.8171 6.87438 11.3468 6.34473 12.0002 6.34473C12.6535 6.34473 13.1832 6.87438 13.1832 7.52775Z"
        fill="currentColor"
      />
      <path d="M10.9818 16.5276H9.7373V17.659H14.263V16.5276H13.0184V9.73901H9.7373V10.8704H10.9818V16.5276Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default StateInfo;
